module.exports = __webpack_public_path__ + "static/img/7.5af9b4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/7.png
// module id = VWHz
// module chunks = 0